module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce.c9dea288.jpeg";